module.exports = __webpack_public_path__ + "img/kehu_4@2x.c557f8d6.png";